/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareUpIcon20Solid = forwardRef('ArrowFigureASquareUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 14a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8Zm4.293-4.251a.9.9 0 0 0 1.271-.062L9.1 7.994V14a.9.9 0 1 0 1.8 0V7.994l1.536 1.693a.9.9 0 1 0 1.333-1.21l-2.362-2.602a1.9 1.9 0 0 0-2.814 0L6.23 8.477a.9.9 0 0 0 .062 1.272Z" })));
});
